import { render, staticRenderFns } from "./addChegua.vue?vue&type=template&id=44e2d775&scoped=true&"
import script from "./addChegua.vue?vue&type=script&lang=js&"
export * from "./addChegua.vue?vue&type=script&lang=js&"
import style0 from "./addChegua.vue?vue&type=style&index=0&id=44e2d775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2d775",
  null
  
)

export default component.exports